/* https://openbase.com/js/react-toastify */


import React, { Component } from 'react';

import Configurator from "./Components/Configurator/Configurator";
import GoToTop from './Components/Scroll/GotoTop';
import { ToastContainer } from 'react-toastify';

//import { ReactSession } from 'react-client-session';


export default class App extends Component {
    static displayName = App.name;

    constructor(props) {
        super(props);

        this.state = { forecasts: [], loading: true, loading2: true};
    }

    render() {

        return (
            <div>
                <Configurator />
                <GoToTop />
                <ToastContainer limit={0} newestOnTop={false} hideProgressBar={ false }/>
            </div>
        );
    }
}
